module.exports = "/_next/static/images/ico-fav-mini-filled-280eb08908778ae6d3d605210553f358.svg";